import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { pageImages } from '../../data/siteData';
import PagePhotoViewer from '../../elements/PagePhotoViewer';
import SelectionImageCarousel from '../../elements/SelectionImageCarousel';

const images = pageImages['vertical-down-packing-baling-presses-balers'];


function VerticalDownPackingBalingPressesBalers() {
  const modelPhotos = [
    { src: '/img/thumbnails/VerticaldownPackingPressesPic4.jpg', alt: 'C&M 60HDD vertical baler', caption: 'CM60HDD with 6" or 7" Cylinder' },
    { src: '/img/thumbnails/VerticaldownPackingPressesPic5.jpg', alt: 'C&M 72HDD vertical baler', caption: 'CM72HDD with 7" Cylinder' },
    { src: '/img/thumbnails/VerticaldownPackingPressesPic6.jpg', alt: 'C&M 48HDD vertical baler', caption: 'CM48HDD with 6" or 7" Cylinder' },
  ];
  const optionPhotos = [
    { src: '/img/thumbnails/VerticaldownPackingPressesPic7.jpg', alt: 'Solid sheeted safety gate', caption: 'Solid Sheeted Safety Gate' },
    { src: '/img/thumbnails/VerticaldownPackingPressesPic8.jpg', alt: 'Slotted tie-through door', caption: 'Slotted Tie-Through Door' },
    { src: '/img/thumbnails/VerticaldownPackingPressesPic9.jpg', alt: 'Double door front loading and rear eject', caption: 'Double-Door for Front Loading and Rear Eject' },
    { src: '/img/thumbnails/VerticaldownPackingPressesPic10.jpg', alt: 'Wire return chutes', caption: 'Wire Return Chutes' },
    { src: '/img/thumbnails/VerticaldownPackingPressesPic11.jpg', alt: 'Bale lifter arm cover', caption: 'Bale Lifter-Arm Cover' },
    { src: '/img/thumbnails/VerticaldownPackingPressesPic12.jpg', alt: 'Spring loaded material hold downs', caption: 'Spring Loaded Material Hold Downs' },
    { src: '/img/equipment/vertical-balers/vertical-1.jpg', alt: 'Green C&M vertical baler with open door', caption: 'Vertical Baler with Open Door' },
    { src: '/img/equipment/vertical-balers/vertical-3.jpg', alt: 'White C&M vertical baler with loading gate', caption: 'Commercial & Warehouse Vertical Baler' },
  ];
  const check = '✓';
  const heavyDutySpecRows = [
    ['Cylinder', '6" or 7" cylinder', '6" or 7" cylinder', '7" cylinder'],
    ['Extra heavy-duty structural steel with strong high-density baling chamber', check, check, check],
    ['Bale size', '48" wide x 30" deep x 24-48" high', '60" wide x 30" deep x 24-48" high', '72" wide x 30" deep x 24-48" high'],
    ['10-HP 230/460 volt hydraulic power unit, PLC or smart relay controls, push-button panel, and 20-gallon hydraulic reservoir with ISO Grade 46 fluid', check, check, check],
    ['C&M Auto-Bale Eject to engage bale eject hooks', check, check, check],
    ['Door and feed gate interlocks with safety gate watch-dog, replaceable UHMW platen wear strips, and adjustable down-stroke time delay for denser bales', check, check, check],
    ['70,650-lbs compression force with 6-inch bore cylinder', check, check, ''],
    ['96,163-lbs compression force with 7-inch bore cylinder', check, check, check],
  ];
  const additionalOptions = [
    ['Material handling options', 'Spring-loaded or gravity material hold downs, wire return chutes, lifting lugs for crane lifting, bale lifter-arm cover, and second auto eject lift assembly'],
    ['Electrical and weather options', 'Hydraulic oil reservoir heater, 380/400/415 volt motors, 220 volt single-phase motor, 15-HP motor for faster ram cycles, NEMA 4 electrical enclosures, weatherizing features, bolt-on hydraulic power unit weather cover, safety relay, and Trojan safety switches'],
    ['Door, tying, and guard options', 'Solid sheeted safety gate, two-hand push-button bale eject control, wire-slot finger guards for rear only, slotted bale door for closed-door bale tying, and recessed bale door safety switch'],
  ];
  return (
    <main className="detail-main">
      <section className="detail-layout">
        <aside>
          <span className="eyebrow">In This Section</span>
          <Link to="/closed-end-manual-tie-balers">Closed-End Manual Tie Balers</Link>
          <Link to="/open-end-automatic-tie-balers">Open-End Automatic Tie Balers</Link>
          <Link to="/wide-mouth-open-end-automatic-tie-balers">Wide-Mouth Open-End Automatic Tie Balers</Link>
          <Link to="/multi-materials-full-eject-closed-end-balers">Multi Materials Full-Eject Closed-End Balers</Link>
          <Link to="/open-end-manual-tie-balers">Open-End Manual Tie Balers</Link>
          <Link to="/cart-lifters-dumpers-dump-carts">Cart Lifters, Dumpers &amp; Dump Carts</Link>
          <Link to="/conveyors-bale-conveying-bagging-systems">Conveyors, Bale Conveying &amp; Bagging Systems</Link>
          <Link to="/used-clothing-balers">Used Clothing Balers</Link>
          <Link to="/cotton-gin-textile-baling-presses">Cotton Gin &amp; Textile Baling Presses</Link>
          <Link to="/biomass-cotton-gin-trash-baling-press">Biomass &amp; Cotton Gin Trash Baling Press</Link>
          <Link className="active" to="/vertical-down-packing-baling-presses-balers">Vertical &amp; Down-Packing Baling Presses &amp; Balers</Link>
          <Link to="/custom-designed-specialty-balers">Custom Designed &amp; Specialty Balers</Link>
          <Link to="/precrush-compactors-waste-compactors">PreCrush Compactors &amp; Waste Compactors</Link>
        </aside>
        <article className="article">
          <span className="eyebrow">Products</span>
          <h2>Vertical &amp; Down-Packing Baling Presses &amp; Balers</h2>
          <div className="body-copy page-summary-copy"><strong>C+M Baling Systems</strong> manufactures many different styles of vertical down packing <strong>baling presses</strong>, from the industry standard 60” wide vertical down packing baler to custom designed verticals.</div>
          <div className="page-summary-notes">
              <span>Common mill-size bale formats</span>
              <span>Low-volume and special material applications</span>
              <span>Heavy-duty and specialty C+M models</span>
          </div>
          <PagePhotoViewer images={images} leadText={"C+M Baling Systems manufactures many different styles of vertical down packing baling presses, from the industry standard 60” wide vertical down packing baler to custom designed verticals. C+M offers many features for our vertical down packing baler line, from low profile vertical balers which can fit into virtually any room, to features on the balers such as, auto-lock eject, rear feed chutes fed by conveyor or cart lifter/dumpers, fixed or spring loaded material retainer “dogs”, wire return chutes, tie-through doors, hydraulic eject, auto cycling, etc. C+M's verticals are manufactured to order and are very heavy-duty. Examples of C+M's vertical down packing balers:"} eyebrow="Equipment Photos" />
          <div className="content-stack">
            <section className="content-block">
              <div className="body-copy">Low profile down-stroke <strong>vertical baler</strong> The low profile down-stroke vertical baler is designed to operate under low ceiling heights. The C+M 2030 LPV has an 18&quot; x 30&quot; front <strong>infeed opening</strong> with a vertical sliding safety gate and electrical interlock. An optional 18&quot; x 30&quot; rear infeed chute system is available.</div>
              <div className="vertical-feature-layout">
                <ul className="vertical-spec-list">
                  <li>95&quot; high 66&quot; wide 48&quot; long with 32&quot; x 61&quot; footprint</li>
                  <li>Easy-to-Handle Bales</li>
                  <li>20&quot; L x 30&quot; W x 20-32&quot; H</li>
                  <li>150-175 lbs bale weight</li>
                  <li>Hydraulic Power Unit</li>
                  <li>Top recessed above platen</li>
                  <li>5 HP 220-volts single &amp; 240/460 3HZ</li>
                  <li>Bale density control</li>
                  <li>Compression System</li>
                  <li>Twin Compression Cylinders</li>
                  <li>30,000 LBS Force</li>
                  <li>Up to 50-PSI platen force</li>
                  <li>Unique C+M &quot;J&quot; bars for proper cylinder stroke</li>
                </ul>
                <div className="equipment-feature-photo compact-feature-photo">
                  <img src="/img/thumbnails/VerticaldownPackingPressesPic1.jpg" alt="C+M low profile down-stroke vertical baler" />
                </div>
              </div>
            </section>
            <section className="content-block">
              <div className="body-copy">3630VHDD &amp; 4020VHDD Vertical Down-Stroke Balers The CM3630VHDD and CM4020VHDD are also in C+M's small line of extra heavy duty vertical down stroke balers and are constructed with a high-density <strong>baling chamber</strong> for 36″ wide x 30″ long x 30-40″ high bales (in-chamber) or 40″ wide x 20″ long x 24-30″ high bales (inchamber).</div>
              <div className="body-copy">These balers are great for small OCC (cardboard), paper trim, office paper, plastic film, textile waste, cloth, industrial packaging waste, metal foil, and many other miscellaneous small materials.</div>
              <div className="equipment-photo-grid two-up contain-gallery">
                <figure>
                  <img src="/img/thumbnails/VerticaldownPackingPressesPic2.jpg" alt="C+M 3630VHDD vertical baler" />
                  <figcaption>CM3630VHDD</figcaption>
                </figure>
                <figure>
                  <img src="/img/thumbnails/VerticaldownPackingPressesPic3.jpg" alt="C+M 4020VHDD vertical baler" />
                  <figcaption>CM4020VHDD</figcaption>
                </figure>
              </div>
            </section>
            
            <SelectionImageCarousel
              eyebrow="Vertical Models"
              intro="CM 48HDD, 60HDD and 72HDD vertical balers are available with C+M Auto-Bale Eject for heavy-duty down-packing applications."
              items={modelPhotos}
              ariaLabel="Extra heavy-duty vertical model photos"
              className="expanded-photo-carousel"
            />
            <section className="vertical-model-table-section">
              <h3>CM 48HDD, 60HDD and 72HDD With C+M Auto-Bale Eject</h3>
              <div className="vertical-model-table-wrap">
                <table className="spec-table vertical-model-table">
                  <thead>
                    <tr>
                      <th>Feature</th>
                      <th>CM48HDD</th>
                      <th>CM60HDD</th>
                      <th>CM72HDD</th>
                    </tr>
                  </thead>
                  <tbody>
                    {heavyDutySpecRows.map(([feature, cm48, cm60, cm72, rowType]) => (
                      rowType === 'section' ? (
                        <tr className="table-section-row" key={feature}>
                          <td colSpan="4">{feature}</td>
                        </tr>
                      ) : (
                        <tr key={feature}>
                          <td>{feature}</td>
                          <td>{cm48}</td>
                          <td>{cm60}</td>
                          <td>{cm72}</td>
                        </tr>
                      )
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="additional-options">
                <h4>Additional Options</h4>
                {additionalOptions.map(([title, text]) => (
                  <p key={title}><strong>{title}:</strong> {text}</p>
                ))}
              </div>
            </section>
            <SelectionImageCarousel
              items={optionPhotos}
              ariaLabel="Extra heavy-duty vertical baler feature photos"
              className="expanded-photo-carousel"
            />
            <section className="content-block">
              <div className="body-copy">Standard Duty Vertical Commercial &amp; Warehouse Balers C+M commercial and warehouse vertical down stroke balers are offered in numerous sizes for various applications. From the smallest 30” wide by 16” deep <strong>baling chamber</strong> size or the largest 72” wide by 40” deep baling chamber, these balers bale most materials and are designed to produce many <strong>bale sizes</strong>. The standard “mill size bale” is 60” wide, 30” long, and 48”-54” high and compressed/baled within a baling chamber 60” wide x 30” deep...definably the most commonly used vertical down stroke baler.</div>
              <div className="body-copy">When a baler is to be located outdoors, NEMA-4 electrics, special paint, and hydraulic fluid heaters are needed.</div>
            </section>
          </div>
          <div className="brochure-links standalone-brochure">
            <a className="button" href="/pdf/CM-Verticals-1-1.pdf" target="_blank" rel="noreferrer">PDF Brochure <ArrowRight size={16} /></a>
          </div>
          <Link className="button" to="/contact/request-quote">Request a Quote <ArrowRight size={16} /></Link>
        </article>
      </section>
    </main>
  );
}

export default VerticalDownPackingBalingPressesBalers;
